import moment from "moment";

moment.locale(process.env.VUE_APP_DEFAULT_LOCALE);
export default moment;
